import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp16};
`

export const Label = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const Helper = styled(Text)`
  color: ${props => props.theme.colors.text.muted};
`
